import React, { useRef, useState, useEffect } from 'react'
import MoreOptions from './../MoreOptions/MoreOptions'
import styles from './OverflowMenu.module.css'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import useCheckIsMobileScreen from 'hooks/checkMobileScreen'
import { isDevSite } from 'utils/general'
import DomainMoreOptions from './../../../CustomDomainTable/components/DomainMoreOptions'

const OverflowMenu = ({
  onEditHTML,
  onEditPDF,
  onArchive,
  onDownload,
  onDownloadAll,
  onAnalytics,
  onQRCode,
  onDelete,
  onCopy,
  onCopyDirectLink,
  onReplaceFile,
  onAddCustomDomain,
  onIntegrations,
  type,
  siteType,
  onEmbed,
  passwordProtected,
  enableEmailGate,
  link,
  inPreviewMode,
  onShare,
  trial,
  disabled,
  onUpgrade,
  icon,
  onAssignToSpace,
  hasSpaces,
  onExportEmails,
  onViewVersions,
  linkId,
  wasmerDnsRecord,
  isPresignedUpload,
  isCustomDomain,
  onAction,
  label,
  iconItem,
  onAnalyseSite,
  onClearCache,
  items
}) => {
  const [show, setShow] = useState(false)
  const ref = useRef(null)
  const { isMobile, isTablet } = useCheckIsMobileScreen()

  const handleClick = () => {
    setShow(!show)
  }

  const handleBlur = () => {
    if (process.env.REACT_APP_ENABLE_E2E !== 'true') setShow(false)
  }

  const handleHover = () => {
    setShow(true)
  }

  const onCustomisePasswordPage = () => {
    if (isDevSite()) {
      window.open(`https://www.tiiny.co.uk/editor/?domain=${link}&file=/_auth/index.html&customize-auth=true`, '_blank')
    } else {
      window.open(`https://tiiny.host/editor/?domain=${link}&file=/_auth/index.html&customize-auth=true`, '_blank')
    }
  }

  return (
    <div
      className={styles.overflowMenu}
      ref={ref}
      onClick={handleClick}
      onMouseLeave={handleBlur}
      onMouseOver={!isMobile ? handleHover : null}
      tabIndex={0}
    >
      <OverlayTrigger
        trigger={[]}
        key={'left'}
        placement={'left'}
        show={show}
        overlay={
          <Popover id={`popover-positioned-left`} className={styles.container}>
            <Popover.Body className={styles.popoverContainer}>
              {!isCustomDomain ? (
                <MoreOptions
                  onEditHTML={onEditHTML}
                  onEditPDF={onEditPDF}
                  onEmbed={onEmbed}
                  onArchive={onArchive}
                  onDownload={onDownload}
                  onDownloadAll={onDownloadAll}
                  onAnalytics={onAnalytics}
                  onQRCode={onQRCode}
                  onDelete={onDelete}
                  onCopy={onCopy}
                  onCopyDirectLink={onCopyDirectLink}
                  onReplaceFile={onReplaceFile}
                  onCustomisePasswordPage={onCustomisePasswordPage}
                  onAddCustomDomain={onAddCustomDomain}
                  onIntegrations={onIntegrations}
                  type={type}
                  siteType={siteType}
                  passwordProtected={passwordProtected}
                  enableEmailGate={enableEmailGate}
                  inPreviewMode={inPreviewMode}
                  onShare={onShare}
                  trial={trial}
                  link={link}
                  onUpgrade={onUpgrade}
                  disabled={disabled}
                  onAssignToSpace={onAssignToSpace}
                  hasSpaces={hasSpaces}
                  onExportEmails={onExportEmails}
                  onViewVersions={onViewVersions}
                  linkId={linkId}
                  wasmerDnsRecord={wasmerDnsRecord}
                  isPresignedUpload={isPresignedUpload}
                  onAnalyseSite={onAnalyseSite}
                  onClearCache={onClearCache}
                />
              ) : (
                <DomainMoreOptions onAction={onAction} label={label} icon={iconItem} items={items} />
              )}
            </Popover.Body>
          </Popover>
        }
      >
        <img src={icon} height={34} data-testid="OverflowMenu-icon-menu" />
      </OverlayTrigger>
    </div>
  )
}

export default OverflowMenu
